"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROW_HEIGHT = exports.OFFSET = void 0;
var OFFSET = exports.OFFSET = 36;
var ROW_HEIGHT = exports.ROW_HEIGHT = 30;